import script from "./Habilidades.vue?vue&type=script&setup=true&lang=ts"
export * from "./Habilidades.vue?vue&type=script&setup=true&lang=ts"

import "./Habilidades.vue?vue&type=style&index=0&id=8e1bdcb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e1bdcb6"]])

export default __exports__